export const SEND_TOAST = 'SEND_TOAST';
export const RESET_TOAST = 'RESET_TOAST';



// WEBPACK FOOTER //
// ./src/store/modules/toast/mutation-types.js